import { useEffect, useState } from "react";
import { IPanelTurnoEduitar } from "./PanelTurnoEditar";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ITurnoBody, ITurnoEdit } from "../../../../../Interfaces/auxiliar/ITurno";
import { TurnoService } from "../../../../../services/auxiliar/turnoService";

export const usePanelEditar=(props:IPanelTurnoEduitar)=>{
  const [disableForm, setDisableForm] = useState<boolean>(true);
   const [status, setStatus] = useState<codigosRespuesta>(0);
   const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:ITurnoEdit={
        nombre: "",
        codigo: "",
        horaInicio: "",
        horaFin: "",
        turnoId:""
    }
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    const [request,setRequest]=useState<ITurnoEdit>(initial)

    useEffect(()=>{
    if(props.isOpen){
      setRequest({...request,nombre:props.item.nombre,turnoId:props.item.turnoId,
        codigo:props.item.codigo,horaFin:props.item.horaFin==null?"":props.item.horaFin.split(":").slice(0, 2).join(":"),
        horaInicio:props.item.horaInicio==null?"":props.item.horaInicio.split(":").slice(0, 2).join(":")})
      }
    },[props.isOpen])
    const putEditarTurno=()=>{
        setLoading(true)
        TurnoService.UpdateTurno(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                  props.reload?.();
                  reset()
              },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,putEditarTurno,loading,disableForm,reset,mensaje,status}
    
}